import { render, staticRenderFns } from "./PaymentToggler.vue?vue&type=template&id=23233fa0&"
import script from "./PaymentToggler.vue?vue&type=script&lang=js&"
export * from "./PaymentToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports